import React from 'react';
import { useSelector } from 'react-redux';

import { Snackbar, SnackbarContent } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import { selectLoginFormMessage } from '../../../state';

function LoginMessageSnackbar() {
  const loginMessage = useSelector(selectLoginFormMessage);

  if (!loginMessage?.message) return '';

  let messageIcon = '';
  const barStyle = { backgroundColor: '#d32f2f' };

  switch (loginMessage.type) {
    case 'error':
      barStyle.backgroundColor = '#d32f2f';
      messageIcon = <ErrorIcon style={{ marginBottom: -6, marginRight: 12 }} />;
      break;
    case 'success':
      barStyle.backgroundColor = '#43a047';
      messageIcon = <CheckIcon style={{ marginBottom: -6, marginRight: 12 }} />;
      break;
    default:
  }

  return (
    <Snackbar
      open
      autoHideDuration={10000}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      style={{
        position: 'absolute',
        bottom: -70,
      }}
    >
      <SnackbarContent
        aria-describedby="client-snackbar"
        style={barStyle}
        message={(
          <span id="client-snackbar">
            {messageIcon}
            {loginMessage.message}
          </span>
        )}
      />
    </Snackbar>
  );
}

export default LoginMessageSnackbar;
